module.exports = __webpack_public_path__ + "assets/img/partner2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner2.png
// module id = 1967
// module chunks = 0